<svelte:options
  customElement={{
    tag: "oc-badge-v1",
    /*                                                         */
    /*         */
    extend: (CustomElementConstructor) =>
      class extends CustomElementConstructor {
        constructor() {
          super();
          this.host = this;
        }
      },
    props: {
      aria: { type: "Object" },
      size: { type: "String", reflect: true },
      variant: { type: "String", reflect: true },
    },
  }}
/>

<script lang="ts">
  import { onMount } from "svelte";
  import type { Props } from "./BadgeV1.types.js";
  import type { CommonProps } from "../../../common/component.types.js";
  import { useAriaAttributes } from "../../../common/utils/aria/useAriaAttributes.js";
  import { applyAttributesToHost } from "../../../common/utils/aria/applyAttributesToHost.js";

  export let aria: Required<CommonProps>["aria"] = {};
  $: {
    const ariaAttributes = useAriaAttributes(aria);
    applyAttributesToHost(ariaAttributes.default);
  }

  export let variant: Props["variant"] = "primary";

  export let size: Props["size"] = "100";

  export let host: HTMLElement;

  onMount(() => {
    host.role = "status";
  });
</script>

<div class="badge">
  {#if size === "100"}
    {#if variant === "success"}
      <oc-icon-v1 size={"50"} color="currentColor" type="check" />
    {:else}
      <slot />
    {/if}
  {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";
  @use "../../../common/scss/focus.scss";
  @use "BadgeV1.config" as config;

  :host {
    @include config.oc-badge;
    color: tokens.$oc-component-badge-100-text-color;
    text-align: center;
    outline-color: tokens.$oc-component-badge-border-color;
  }

  :host([size="100"]) {
    @include config.oc-badge-100;
    border-radius: 8px; /*                                                          */
  }

  :host([size="100"][variant="primary"]) {
    background-color: tokens.$oc-component-badge-primary-background-color;
  }

  :host([size="100"][variant="secondary"]) {
    background-color: tokens.$oc-component-badge-secondary-background-color;
  }

  :host([variant="success"]) {
    @include config.oc-badge-100-success;
    background-color: tokens.$oc-component-badge-success-background-color;
  }

  :host([size="50"]) {
    @include config.oc-badge-50;
    border-radius: 50%;
    background-color: tokens.$oc-component-badge-primary-background-color;
  }
</style>
